import ManageContentScreen from '../components/ManageContentScreen';

const ManageBrochures = () => {
  return (
    <ManageContentScreen
      type="brochures"
      title="Manage Brochures"
      backPath="/profile"
    />
  );
};

export default ManageBrochures;
